import React, { Dispatch, PropsWithChildren, SetStateAction } from 'react'
import { ThumbnailDisplay } from '../video/factor/ThumbnailDisplay'
import { AiScriptDisplay } from '../video/factor/AiScriptDisplay'
import { SubtitleDisplay } from '../video/factor/subtitle'
import { BgmDisplay } from '../video/factor/BgmDisplay'
import { Transition } from '../video/factor/Transition'
import { PriceDisplay } from '../video/factor/PriceDisplay'
import { IncludeAddDisplay } from '../video/factor/IncludeAddDisplay'
import { IntroDisplay } from '../video/factor/IntroDisplay'
import { StickerDisplay } from '../video/factor/StickerDisplay'
import { OutroDisplay } from '../video/factor/OutroDisplay'
import { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import { FormValues } from 'utils/type'
import { Me } from 'service/user'
import {
  AiThumbnailTitle,
  BgmFactor,
  IntroFactor,
  LinkDetailType,
  OutroFactor,
  PromptGroup,
  StickerLocationType,
  StickerType,
  SubtitleColorType,
  SubtitleType,
  ThumbnailType,
  TransitionFactor,
  VoiceGroupFactor,
  VoiceTagType,
} from 'service/list'
interface FastcutLongformEffectSelectorProps {
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
  userInfo: Me
  thumbnailList: ThumbnailType[]
  thumbnailPlacIdList: ThumbnailType[]
  translatePlanName: (planName: string) => string
  error: any
  setError: Dispatch<SetStateAction<any>>
  isOpenLinkMethod: boolean
  selectedLinks: LinkDetailType[]
  aiRecommendThumbnailTitle: AiThumbnailTitle | null
  placIdThumbnail: { id: number; path: string }[]
  setPlacIdThumbnail: Dispatch<SetStateAction<{ id: number; path: string }[]>>
  isSaveThumbnail: boolean
  setIsSaveThumbnail: Dispatch<SetStateAction<boolean>>
  thumbNailDivRef: React.MutableRefObject<HTMLDivElement | null>
  selectedPlacIdThumbnail: { id: number; path: string } | null
  setSelectedPlacIdThumbnail: Dispatch<
    SetStateAction<{ id: number; path: string } | null>
  >
  selectedItem: ThumbnailType | null
  setSelectedItem: Dispatch<SetStateAction<ThumbnailType | null>>
  promptGroup: PromptGroup[] | undefined
  voiceList: VoiceGroupFactor[] | undefined
  userVoiceList: VoiceGroupFactor[] | undefined
  setPromptStatus: Dispatch<SetStateAction<boolean[]>>
  setVoicePlaying: Dispatch<SetStateAction<boolean[]>>
  setToneTooltip: Dispatch<SetStateAction<boolean[]>>
  promptStatus: boolean[]
  voicePlaying: boolean[]
  toneTooltip: boolean[]
  voiceTags: VoiceTagType | undefined
  userVoiceRefetch: any
  subTitleList: SubtitleType[] | []
  subtitleColorList: SubtitleColorType[] | []
  subtitleFontList: SubtitleColorType[] | []
  subtitleSizeList: SubtitleColorType[] | []
  subtitleDivRef?: React.MutableRefObject<HTMLDivElement | null>
  bgmList: BgmFactor[] | []
  bgmRefs: React.MutableRefObject<(HTMLAudioElement | null)[]>
  setBgmPlaying: Dispatch<SetStateAction<boolean[]>>
  bgmPlaying: boolean[]
  handleBgmPlayButtonClick: (status: boolean, index: number) => void
  copyTransitionList: TransitionFactor[] | []
  setSelectedTransitionIndex: Dispatch<SetStateAction<number>>
  selectedTransitionIndex: number
  setTransitionModal: Dispatch<SetStateAction<boolean>>
  handlePlayButtonClick: (index: number) => void
  handleVideoEnded: (index: number) => void
  handleMouseLeave: (index: number) => void
  handleSelectedTransition: (behavior: boolean) => void
  videoRefs: React.MutableRefObject<(HTMLVideoElement | null)[]>
  videoRef: React.MutableRefObject<HTMLVideoElement | null>
  transitionDivRef: React.MutableRefObject<HTMLDivElement | null>
  videoPlaying: boolean[]
  introList: IntroFactor[] | []
  stickerList: StickerType[] | undefined
  stickerLocationList: StickerLocationType[] | undefined
  copyOutroList: OutroFactor[] | []
  setCopyOutroList: Dispatch<SetStateAction<[] | OutroFactor[]>>
}
export const FastcutLongformEffectSelector = ({
  watch,
  setValue,
  control,
  userInfo,
  thumbnailList,
  thumbnailPlacIdList,
  translatePlanName,
  error,
  setError,
  isOpenLinkMethod,
  selectedLinks,
  aiRecommendThumbnailTitle,
  placIdThumbnail,
  setPlacIdThumbnail,
  isSaveThumbnail,
  setIsSaveThumbnail,
  thumbNailDivRef,
  selectedPlacIdThumbnail,
  setSelectedPlacIdThumbnail,
  selectedItem,
  setSelectedItem,
  promptGroup,
  setPromptStatus,
  promptStatus,
  voiceList,
  userVoiceList,
  setVoicePlaying,
  voicePlaying,
  voiceTags,
  setToneTooltip,
  toneTooltip,
  userVoiceRefetch,
  subTitleList,
  subtitleColorList,
  subtitleDivRef,
  bgmList,
  bgmRefs,
  setBgmPlaying,
  bgmPlaying,
  handleBgmPlayButtonClick,
  copyTransitionList,
  setSelectedTransitionIndex,
  selectedTransitionIndex,
  setTransitionModal,
  handlePlayButtonClick,
  handleVideoEnded,
  handleMouseLeave,
  handleSelectedTransition,
  videoRefs,
  videoRef,
  transitionDivRef,
  videoPlaying,
  introList,
  stickerList,
  stickerLocationList,
  copyOutroList,
  setCopyOutroList,
  subtitleFontList,
  subtitleSizeList,
}: PropsWithChildren<FastcutLongformEffectSelectorProps>) => {
  return (
    <div className="">
      <ThumbnailDisplay
        watch={watch}
        setValue={setValue}
        userInfo={userInfo}
        control={control}
        thumbnailList={thumbnailList ?? []}
        thumbnailPlacIdList={thumbnailPlacIdList ?? []}
        translatePlanName={translatePlanName}
        error={error}
        setError={setError}
        isOpenLinkMethod={isOpenLinkMethod}
        selectedLinks={selectedLinks}
        aiRecommendThumbnailTitle={aiRecommendThumbnailTitle}
        placIdThumbnail={placIdThumbnail}
        setPlacIdThumbnail={setPlacIdThumbnail}
        isSaveThumbnail={isSaveThumbnail}
        setIsSaveThumbnail={setIsSaveThumbnail}
        thumbNailDivRef={thumbNailDivRef}
        selectedPlacIdThumbnail={selectedPlacIdThumbnail}
        setSelectedPlacIdThumbnail={setSelectedPlacIdThumbnail}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
      />
      {/* 목소리  */}
      <AiScriptDisplay
        watch={watch}
        setValue={setValue}
        control={control}
        translatePlanName={translatePlanName}
        userInfo={userInfo}
        promptGroup={promptGroup}
        setPromptStatus={setPromptStatus}
        promptStatus={promptStatus}
        voiceList={voiceList}
        userVoiceList={userVoiceList}
        setVoicePlaying={setVoicePlaying}
        voicePlaying={voicePlaying}
        voiceTags={voiceTags}
        setToneTooltip={setToneTooltip}
        toneTooltip={toneTooltip}
        userVoiceRefetch={userVoiceRefetch}
      />

      <SubtitleDisplay
        subTitleList={subTitleList ?? []}
        subtitleColorList={subtitleColorList ?? []}
        subtitleFontList={subtitleFontList ?? []}
        subtitleSizeList={subtitleSizeList ?? []}
        watch={watch}
        control={control}
        setValue={setValue}
        userInfo={userInfo}
        translatePlanName={translatePlanName}
        subtitleDivRef={subtitleDivRef}
      />

      {/* BGM  선택   */}
      <BgmDisplay
        bgmList={bgmList ?? []}
        setBgmPlaying={setBgmPlaying}
        bgmPlaying={bgmPlaying}
        watch={watch}
        setValue={setValue}
        translatePlanName={translatePlanName}
        bgmRefs={bgmRefs}
        handleBgmPlayButtonClick={handleBgmPlayButtonClick}
        userInfo={userInfo}
        control={control}
      />

      {/* 트랜지션 선택  */}
      <Transition
        watch={watch}
        setValue={setValue}
        control={control}
        translatePlanName={translatePlanName}
        setSelectedTransitionIndex={setSelectedTransitionIndex}
        handleMouseLeave={handleMouseLeave}
        handleVideoEnded={handleVideoEnded}
        copyTransitionList={copyTransitionList}
        handlePlayButtonClick={handlePlayButtonClick}
        userInfo={userInfo}
        videoPlaying={videoPlaying}
        videoRefs={videoRefs}
        videoRef={videoRef}
        selectedTransitionIndex={selectedTransitionIndex}
        setTransitionModal={setTransitionModal}
        handleSelectedTransition={handleSelectedTransition}
        transitionDivRef={transitionDivRef}
      />

      {/* 상품가격정보 넣기/빼기   */}
      <PriceDisplay
        watch={watch}
        setValue={setValue}
        control={control}
        userInfo={userInfo}
      />
      {/* 영상 우상단 안내 이미지 */}
      <IncludeAddDisplay
        watch={watch}
        setValue={setValue}
        control={control}
        userInfo={userInfo}
      />

      {/* 영상 시작 인트로 넣기/빼기*/}
      <IntroDisplay
        userInfo={userInfo}
        watch={watch}
        setValue={setValue}
        control={control}
        translatePlanName={translatePlanName}
        introList={introList ?? []}
      />

      <StickerDisplay
        userInfo={userInfo}
        watch={watch}
        setValue={setValue}
        control={control}
        translatePlanName={translatePlanName}
        stickerLocationList={stickerLocationList}
        stickerList={stickerList}
      />
      {/* 좋구알 list  */}
      <OutroDisplay
        userInfo={userInfo}
        watch={watch}
        setValue={setValue}
        control={control}
        translatePlanName={translatePlanName}
        copyOutroList={copyOutroList}
        setCopyOutroList={setCopyOutroList}
      />
    </div>
  )
}
